<script setup>
import { DriverStore } from '../pinia/Driver'
import PremiumForm from './premiumForm.vue'
import benefits from '../configs/premium.json'

const Driver = DriverStore()
</script>

<template><div class="settings-tab-page premiumCard">
    <div class="settings-tab-header">
      <div class="header-icon"><v-icon size="28">mdi-star</v-icon></div>
      <div class="header-content">
        <h3 class="page-title">Premium</h3>
        <p v-if="Driver.user.premium == '1'" class="page-subtitle">You are a Premium member — thank you for your support!</p>
        <p v-else class="page-subtitle">Unlock exclusive features and support the project</p>
      </div>
    </div>
    <div class="section-list">
      <div class="section-row">
        <div class="section-body">
          <div class="setting-item">
            <div class="setting-info full-width">
              <div class="setting-label">
                <v-icon size="20" class="mr-2">mdi-star-check</v-icon>
                Premium Benefits
              </div>
              <div v-if="Driver.user.premium == '1'" class="setting-description">The following benefits are active on your account</div>
              <div v-else class="setting-description">What you'll get with Premium membership</div>
              <div class="benefits-list">
                <div v-for="benefit in benefits" :key="benefit.title" class="benefit-item">
                  <div class="benefit-icon"><v-icon size="24">{{ `mdi-${benefit.icone}` }}</v-icon></div>
                  <div class="benefit-content">
                    <div class="benefit-title">{{ benefit.title }}</div>
                    <div class="benefit-text" v-html="benefit.text" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="Driver.user.premium == '0'" class="section-row">
        <div class="section-body">
          <div class="setting-item">
            <div class="setting-info full-width">
              <div class="setting-label">
                <v-icon size="20" class="mr-2">mdi-credit-card</v-icon>
                Get Premium
              </div>
              <div class="setting-description">Complete checkout with Stripe to activate Premium</div>
              <PremiumForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div></template>

<style scoped>
.benefits-list {
  display:flex;
  flex-direction:column;
  gap:12px}
.benefit-item {
  display:flex;
  align-items:flex-start;
  gap:12px;
  padding:12px;
  background:var(--glass);
  border:1px solid var(--line);
  border-radius:8px}
.benefit-icon {
  display:flex;
  align-items:center;
  justify-content:center;
  width:40px;
  height:40px;
  background:rgba(var(--v-theme-primary),.15);
  border-radius:8px;
  flex-shrink:0}
.benefit-icon .v-icon {
  color:rgb(var(--v-theme-primary))}
.benefit-content {
  flex:1}
.benefit-title {
  font-size:.95em;
  font-weight:500;
  color:var(--ink);
  margin-bottom:4px}
.benefit-text {
  font-size:.85em;
  color:var(--mute);
  line-height:1.4}
</style>
